import { useState, useCallback, useEffect, useRef } from 'react';
import { useQuery } from 'react-query';
import { captureException } from '@sentry/nextjs';
import { LeadService } from '~/src/services/lead.service';
import { TechAbilityEnum } from '~/src/models/enums/tech-ability.enum';

const QUERY_KEY = 'get tech ability';

export const useFetchGetTechAbility = () => {
    const [isReset, setIsReset] = useState(false);
    const [currentFiasId, setCurrentFiasId] = useState('');
    const [fetchCount, setFetchCount] = useState(0);
    const shouldFetch = useRef(false);

    const { refetch, data, isLoading, isError } = useQuery(
        [QUERY_KEY, currentFiasId],
        () => LeadService.getTechAbility(currentFiasId, true),
        {
            onSuccess: (data: { techAbility: TechAbilityEnum }) => {
                return data;
            },
            onError: (error) => {
                captureException(error);
                // eslint-disable-next-line no-console
                console.log(QUERY_KEY, error);
            },
            enabled: false,
        },
    );

    useEffect(() => {
        if (shouldFetch.current && currentFiasId) {
            refetch();
        }
    }, [currentFiasId, fetchCount, refetch]);

    const fetchTechAbility = useCallback((houseFiasId: string) => {
        shouldFetch.current = true;
        setIsReset(false);
        setCurrentFiasId(houseFiasId);
        setFetchCount((prev) => prev + 1);
    }, []);

    const reset = useCallback(() => {
        shouldFetch.current = false;
        setIsReset(true);
    }, []);

    return {
        fetchTechAbility,
        data: isReset ? undefined : data,
        isLoading: isReset ? false : isLoading,
        isError: isReset ? false : isError,
        reset,
    };
};